import React from 'react';
import FormRender from "v4/components/form/FormRender/FormRender";
import useMapImportColumnFieldsConcatenationField
    from "v4/pages/admin/Import/components/ImportSteps/components/MapImport/components/MapImportColumnFields/components/hooks/useMapImportColumnFieldsConcatenationField";
import FormRow from "v4/components/form/FormRender/components/FormRow/FormRow";

export default function MapImportColumnFieldsConcatenationField({fieldToUpdate}) {
    const {form, methods} = useMapImportColumnFieldsConcatenationField(fieldToUpdate);

    return (
        <FormRender form={form}
                    methods={methods}
                    formRender={() => <FormRow fieldName="concatenationField"/>}
        />
    )
}
